import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { categoryData } from '../components/CategoryDirectory';
import { ChevronRight } from 'lucide-react';
export function SitemapPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-886">
      <ModernHeader data-id="element-887" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-888">
        <div className="max-w-7xl mx-auto px-4" data-id="element-889">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-890">
            Site Map
          </h1>
          <p className="text-gray-300 text-center mt-2" data-id="element-891">
            Complete listing of all product categories
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="py-12 md:py-16" data-id="element-892">
        <div className="max-w-6xl mx-auto px-4" data-id="element-893">
          {/* Quick Navigation */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8" data-id="element-894">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-895">
              Quick Navigation
            </h2>
            <div className="flex flex-wrap gap-2" data-id="element-896">
              {categoryData.map(group => <a key={group.title} href={`#${group.title.toLowerCase().replace(/\s+/g, '-').replace(/[&\/]/g, '')}`} className="px-4 py-2 bg-gray-100 hover:bg-red-100 text-gray-700 hover:text-red-700 rounded-lg text-sm font-medium transition-colors" data-id="element-897">
                  {group.title}
                </a>)}
            </div>
          </div>

          {/* All Categories */}
          <div className="space-y-6" data-id="element-898">
            {categoryData.map(group => <div key={group.title} id={group.title.toLowerCase().replace(/\s+/g, '-').replace(/[&\/]/g, '')} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-899">
                <div className="bg-red-700 px-6 py-4" data-id="element-900">
                  <h2 className="text-xl font-bold text-white" data-id="element-901">
                    {group.title}
                  </h2>
                  <p className="text-red-100 text-sm" data-id="element-902">
                    {group.categories.length} subcategories
                  </p>
                </div>
                <div className="p-6" data-id="element-903">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-904">
                    {group.categories.map(category => <a key={category.url} href={category.url} className="flex items-center gap-2 p-3 rounded-lg border border-gray-200 hover:border-red-300 hover:bg-red-50 transition-colors group" data-id="element-905">
                        <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-red-600 flex-shrink-0" data-id="element-906" />
                        <span className="text-blue-700 group-hover:text-red-700 text-sm font-medium" data-id="element-907">
                          {category.name}
                        </span>
                      </a>)}
                  </div>
                </div>
              </div>)}
          </div>

          {/* Summary */}
          <div className="mt-8 bg-gray-800 rounded-xl p-6 text-center" data-id="element-908">
            <p className="text-white text-lg" data-id="element-909">
              <strong data-id="element-910">{categoryData.length}</strong> main categories with{' '}
              <strong data-id="element-911">
                {categoryData.reduce((acc, group) => acc + group.categories.length, 0)}
              </strong>{' '}
              total subcategories
            </p>
            <p className="text-gray-400 text-sm mt-2" data-id="element-912">
              Can't find what you're looking for? Contact us at{' '}
              <a href="mailto:sales@usabearingsandbelts.com" className="text-blue-400 hover:text-blue-300" data-id="element-913">
                sales@usabearingsandbelts.com
              </a>
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-914" />
    </div>;
}